import { getImageSize, isImageFile } from '@/utils/fs/image.utils';
import { Modal } from 'ant-design-vue';
import { useWatchfaceStore } from '@/store/use-watchface-store';

let errorModal: number | undefined;
export const useWatchfaceImageValid = () => {
  const watchfaceStore = useWatchfaceStore();

  const showErrorModal = (imgPath: string, err: string) => {
    if (errorModal) {
      window.clearTimeout(errorModal);
      errorModal = 0;
    }
    errorModal = window.setTimeout(() => {
      Modal.error({
        title: '图片资源有误',
        content: err
      });
    }, 30);
  };

  /**
   * 验证图片资源，并modal提示错误信息
   * @param imgPath
   * @param options
   * @returns
   */
  const validImageSize = async (imgPath: string) => {
    if (!isImageFile(imgPath, 'png')) {
      showErrorModal(imgPath, '图片类型仅支持png格式');
      return false;
    }

    const { height = 0, width = 0 } = (await getImageSize(imgPath)) ?? {};
    const { width: widgetLimit, height: heightLimit } = watchfaceStore.size;
    if (width > widgetLimit || height > heightLimit) {
      showErrorModal(imgPath, `图片宽高不可超过${widgetLimit}*${heightLimit}`);
      return false;
    }
    return true;
  };

  // /**
  //  * 校验同一图层在不同配色下的资源尺寸是否一致
  //  */
  // const validSizeBetweenColors = async (data: {
  //   imagePath: string;
  //   shape: Shape;
  //   colorGroup: string;
  //   resourceName: ResourceKey;
  // }) => {
  //   const { shape, colorGroup, resourceName, imagePath } = data;
  //   const { resources } = shape.attrs;
  //   const colorIds = Object.keys(resources?.[resourceName] ?? {});
  //   if (!colorIds.length || !resources?.[resourceName]) return true;

  //   // 获取已有配色的图片大小
  //   const anotherColor = colorIds.find((colorId) => colorId != colorGroup);
  //   if (!anotherColor) return true;

  //   const { width, height } =
  //     getImgDom(resources?.[resourceName]?.[anotherColor]?.[0] ?? '') ?? {};
  //   if (!width || !height) return true;

  //   // 获取当前图片大小
  //   const { width: width2, height: height2 } =
  //     (await getImageSize(imagePath)) ?? {};
  //   if (width2 != width || height2 != height) {
  //     showErrorModal('', '该图片与其他配色下图片尺寸不一致');
  //     return false;
  //   }
  //   return true;
  // };

  const isSameSize = async (filenames: string[]) => {
    let w = 0;
    let h = 0;
    let valid = true;
    for (let i = 0; i < filenames.length; i++) {
      const filename = filenames[i];
      const { width = 0, height = 0 } = (await getImageSize(filename)) ?? {};
      if (i == 0) {
        w = width;
        h = height;
      } else {
        if (width != w || h != height) {
          valid = false;
          break;
        }
      }
    }
    return valid;
  };

  return { validImageSize, isSameSize };
};
